import { PageListCachedDataSource } from './BaseDataSources';

export class UserByRoleSource extends PageListCachedDataSource<string> {
  public constructor(role?: string) {
    super('/datasource/usersbyrole', { role });
  }
}